// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1565":"cb42fe55","2113":"afae4f37","8995":"8a51cc32"}[chunkId] + ".chunk.css";
};